// extracted by mini-css-extract-plugin
export var wrapper = "ania-bartek-about-module--wrapper--98023";